import { createContext, useContext } from 'react';

import { defaultTreeMapConfig } from '../defaults.js';
import type { LabelsDisplay } from '../types/treemap.js';

export const LabelsDisplayContext = createContext<LabelsDisplay>(
  defaultTreeMapConfig.labelsDisplay,
);

export const useLabelsDisplay = () => useContext(LabelsDisplayContext);

LabelsDisplayContext['displayName'] = 'LabelsDisplayContext';
